<template>
  <div class="full-height">
    <crud-layout :name="name" :interface="nmInterface" :id="id" :page="page" :page-detail="page"/>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import PersonPage from './PersonPage'
const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'Person',
  components: { CrudLayout, PersonPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Person extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return PersonPage
  }
}
export default Person
</script>
<style lang="stylus" scoped></style>
